import React from 'react';
import { ArrowLong } from '../../assets/img/svg/icons';

import logo from "../../../src/assets/img/uniexpo.webp";

interface NewsComponentProps {
    title: string;
    slug: string;
    date: Date;
    thumbnail: string;
    type: string;
    local: string;
}

const Event: React.FC<NewsComponentProps> = ({ title, slug, date, thumbnail, type, local }) => {

    const now = new Date();

    return (
        <a href={`/agenda-de-eventos/${slug}`} title={title} className='group inline-block'>
            <div className="relative">
                <div className="bg-slate-100 relative rounded-lg overflow-hidden after:content-[''] after:absolute after:left-0 after:right-0 after:bottom-0 after:h-full after:bg-gradient-to-t after:from-black after:to-transparent">
                    {thumbnail ? 
                        <img src={thumbnail} alt={title} className='w-full h-72 object-cover group-hover:scale-105 transition-all duration-200' />
                    : 
                        <img src={logo} alt="Logo Uniexpo" className='h-72 w-1/2 object-contain pl-4 pt-4 object-left-top group-hover:scale-105 transition-all duration-200' />
                    }
                </div>

                <div className="flex items-end gap-4 z-10 absolute bottom-4 left-4">
                    {date && 
                        <div className="flex flex-col shrink-0 h-24 text-center w-16">
                            <div className="flex items-center justify-center bg-main-pink border-2 border-main-pink rounded-t-xl text-white text-4xl font-semibold h-1/2 transition-all duration-200">
                                {date.toLocaleDateString('pt-br', { day: '2-digit'})}
                            </div>

                            <div className="flex flex-col items-center justify-center border-2 border-white rounded-b-xl text-white shrink-0 h-1/2 py-2 px-0">
                                <span className="text-xl font-semibold tracking-wider uppercase -mt-1">
                                    {date.toLocaleDateString('pt-br', { month: 'short'}).replace('.', '')}
                                </span>
                                <span className="text-xs font-semibold tracking-[3px] indent-[2px] -mt-1">
                                    {date.toLocaleDateString('pt-br', { year: 'numeric'})}
                                </span>
                            </div>
                        </div>
                    }
                    
                    <span className='font-light text-white z-10 text-sm pb-1'>
                        Evento 
                        {type &&
                            <span className={`font-semibold ${type === 'Presencial' ? 'text-main-pink' : 'text-main-blue'}`}>
                                &nbsp; {type}.
                            </span>
                        }
                    </span>
                </div>
            </div>

            <div className='py-4 leading-5 text-center text-sm border-b border-black/20'>
                <h3 className="font-semibold text-lg">
                    {title}
                </h3>
                
                {local &&
                    <p className='font-light max-w-96 mx-auto'>
                        <span className='font-semibold'>Local: </span> 
                        {local}
                    </p>
                }
            </div>
            
            
            <div className="font-semibold text-center mt-4 text-sm relative flex items-center justify-center gap-6 translate-x-8">
                {date > now ? 'Saiba mais' : 'Evento realizado'}

                <div className="bg-[#00A3E3] w-14 h-8 rounded-lg flex items-center justify-center drop-shadow-xl transition-all duration-200 group-hover:translate-x-2 group-hover:bg-main-blue">
                    <ArrowLong />
                </div>
            </div>
        </a>
    );
};

export default Event;
